import { ChatbotFlow } from '../../zustand/stores/copilot';

export type IframeMessageHandler = (event: MessageEvent) => void;

export interface ChatbotControls {
  goBack: () => void;
  setShowRightSideBar: (show: boolean) => void;
  selfArticleRedirect: (url: string) => void;
  setIsChatbotReady: (ready: boolean) => void;
  setChatbotFlow: (flow: ChatbotFlow) => void;
  setUnreadMessagesCount: (count: number) => void;
  chatbotReferral: string | null;
}

enum IframeMessageEvents {
  GO_BACK_COPILOT = 'goBackCopilot',
  DISMISS_COPILOT = 'dismissCopilot',
  CHATBOT_FLOW_UPDATE = 'copilotUpdateChatFlow',
  MESSAGE_READY = 'messageReady',
  ARTICLE_OPEN = 'articleOpen',
  COPILOT_READY_TO_BE_INITIALIZED = 'copilotReadyToBeInitialized',
}

export const createIframeMessageHandler =
(controls: ChatbotControls): IframeMessageHandler => (event: MessageEvent) => {
    const allowedOrigins = ['https://www.wix.com'];
    if (!allowedOrigins.includes(event.origin)) {
      return;
    }

    try {
      const messageData = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

      switch (messageData.data.event) {
        case IframeMessageEvents.GO_BACK_COPILOT:
          controls.goBack();
          break;
        case IframeMessageEvents.DISMISS_COPILOT:
          controls.setShowRightSideBar(false);
          break;
        case IframeMessageEvents.MESSAGE_READY:
          controls.setIsChatbotReady(true);
          break;
        case IframeMessageEvents.ARTICLE_OPEN: {
            const url = messageData.data.url;
            const uri = new URL(url).pathname;
            controls.selfArticleRedirect(uri);
            break;
          }
         case IframeMessageEvents.CHATBOT_FLOW_UPDATE: {
           const flow = messageData.data.flow as ChatbotFlow;
           controls.setChatbotFlow(flow ?? ChatbotFlow.REGULAR);
           break;
          }
          case IframeMessageEvents.COPILOT_READY_TO_BE_INITIALIZED: {
            initChatbotParams(window?.location.href, controls.chatbotReferral ?? undefined);
            isCopilotChatbotVisible(true);
            controls.setUnreadMessagesCount(0);
            break;
          }
        default:
          // Handle other message types as needed
          break;
      }
    } catch (error) {
      console.error('Error parsing chatbot iframe message:', error);
    }
  };

const COPILOT_CHATBOT_MESSAGE_TYPE = 'COPILOT_CHATBOT';

enum ChatbotOutboundEvents {
  PRE_MESSAGE_SEND = 'pre_message_send',
  INIT_COPILOT_PARAMS = 'init_copilot_params',
  IS_COPILOT_CHATBOT_VISIBLE = 'is_copilot_chatbot_visible',
}

export const sendMessageToChatbot = (query: string) => {
      const iframe = document.getElementById('chatbot-iframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ event: ChatbotOutboundEvents.PRE_MESSAGE_SEND, type: COPILOT_CHATBOT_MESSAGE_TYPE, query }, '*');
      }
    };

export const initChatbotParams = (loadPageUrl: string, referral?: string) => {
      const iframe = document.getElementById('chatbot-iframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ event: ChatbotOutboundEvents.INIT_COPILOT_PARAMS, type: COPILOT_CHATBOT_MESSAGE_TYPE, loadPageUrl, referral }, '*');
      }
};

export const isCopilotChatbotVisible = (isVisible: boolean) => {
      const iframe = document.getElementById('chatbot-iframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ event: ChatbotOutboundEvents.IS_COPILOT_CHATBOT_VISIBLE, type: COPILOT_CHATBOT_MESSAGE_TYPE, isVisible }, '*');
      }
};
